import React from "react";
import { IconButton, InputLabel, Tooltip } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";

export default function InputLabelWithToolTip({
  className = "compLabel",
  labelHeading = "",
  isRequired = false,
  disabled = false,
  toolTip = "",
  id = ""
}) {
  return (
    <InputLabel id={id} disabled={disabled} size={"small"} className={className}>
      <span>{labelHeading}</span>
      {isRequired && <span className={"requiredFldText"}>{" *"}</span>}
      {toolTip && (
        <Tooltip title={toolTip}>
          <IconButton size={"small"} className={"tooltip-iconSize"}>
            <InfoOutlined fontSize={"inherit"} />
          </IconButton>
        </Tooltip>
      )}
    </InputLabel>
  );
}
